import { render, staticRenderFns } from "./SaveInvoice.vue?vue&type=template&id=31b62452&"
import script from "./SaveInvoice.vue?vue&type=script&lang=js&"
export * from "./SaveInvoice.vue?vue&type=script&lang=js&"
import style0 from "./SaveInvoice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports